<template>
  <v-container fluid ma-0 pa-0>
    <v-navigation-drawer app v-model="drawer">
    
    <template v-slot:prepend>
        <div class="pa-2">
          <div class="title font-weight-bold primary--text">DreamROI v2.0</div>
        </div>
      </template>
    
    
    <v-list-item v-if="$vuetify.breakpoint.mobile">
        
        <v-list-item-content>
          <v-list-item-title class="title font-weight-bold">
            {{ item ? item.name : $t('common.loading')}}
          </v-list-item-title>
          <v-list-item-subtitle>
            {{ $t('domains.projectAdministration') }}
          </v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-action>
            <action-button :tooltip="$t('domains.backToCompany')" icon="$up" :to="`/companies/${company}`" />  
        </v-list-item-action>
      </v-list-item>

      <v-divider></v-divider>
      
      <v-list
        nav
        dense
      >
      <template v-for="mi in menu">
        <v-list-item
          :id="mi.id"
          v-if="!mi.children"
          :key="mi.title"
          :to="mi.to"
          :exact="mi.exact"
          
        >
          <v-list-item-icon>
            <v-icon :color="mi.color">{{ mi.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title><span :style="{color: mi.color ? $vuetify.theme.themes.light[mi.color] : null}">{{ mi.title }}</span></v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-group v-else
          :id="mi.id"
          :key="mi.title"
          :xvalue="mi.open"
          :group="mi.group"
          :prepend-icon="mi.icon"
      >
          <template v-slot:activator>
          <v-list-item-title>{{ mi.title }}</v-list-item-title>
          </template>
          <v-list-item class="ml-2"
          v-for="smi in mi.children"
          :id="smi.id"
          :key="smi.title"
          :to="smi.to"
          :exact="smi.exact"
        >
          <v-list-item-icon>
            <v-icon>{{ smi.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{ smi.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        </v-list-group>
      </template>
      </v-list>


    <v-list>

    </v-list>
    </v-navigation-drawer>
    
    <!-- 
      Moved to field form component
      <wizard-stepper v-if="wizard" :steps="currentWizard" :step="displayStep" class="mb-5" /> -->
    <v-banner dark single-line elevation="10" color="error" icon="$warn" v-if="!isActive && !isBlocked" width="100%">
            {{ $t('companies.inactive') }}
            <template v-slot:actions>
            <v-btn
                text
                href="mailto:support@dreamroi.com"
                target="_blank"
            >
            {{ $t('common.contactSupport')}}
            </v-btn>
            </template>
    </v-banner>
    
    <v-banner single-line elevation="10" color="warning" icon="$warn" v-if="isTrial"  width="100%">
            {{ $t('companies.trial') }}
            <template v-slot:actions>
            <v-btn
                text
                :to="{name: 'plan'}"
            >
            {{ $t('companies.selectPlan')}}
            </v-btn>
            </template>
    </v-banner>
    <router-view />
    <v-dialog v-if="isBlocked && (!isHelpdesk || showBlocked)" :max-width="$vuetify.breakpoint.mobile ? '100%' : '30%'" :value="true" persistent>
    <v-card v-if="item">
      <v-card-title><v-icon left color="warning">$warn</v-icon>{{ $t('domain.blocked.title') }}</v-card-title>
      <v-card-text>{{ $t('domain.blocked.text') }}</v-card-text>
      <v-card-title>{{ $t('domain.blocked.stats.header') }}</v-card-title>
      <v-list>
      <v-list-item>
        <v-list-item-icon><v-icon>$date</v-icon></v-list-item-icon>
         <v-list-item-content>
           <v-list-item-subtitle>{{ $t('domain.blocked.stats.period') }}</v-list-item-subtitle>
           <v-list-item-title>{{ formatDate(subscription.from, true) }} - {{ formatDate(subscription.to, true) }}</v-list-item-title>
         </v-list-item-content>
      </v-list-item>
      <v-subheader>{{ $t('domain.blocked.stats.domain').toUpperCase() }}</v-subheader>
      <v-list-item>
        <v-list-item-icon><v-icon>$visitors</v-icon></v-list-item-icon>
         <v-list-item-content>
           <v-list-item-subtitle>{{ $t('domain.blocked.stats.visitors') }}</v-list-item-subtitle>
           <v-list-item-title>{{ item.stats.monthlyUsers }}</v-list-item-title>
         </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-icon><v-icon>$sales</v-icon></v-list-item-icon>
         <v-list-item-content>
           <v-list-item-subtitle>{{ $t('domain.blocked.stats.sales') }}</v-list-item-subtitle>
           <v-list-item-title>{{ formatCurrencyAmount(item.stats.dreamroiSales, item.currency, 0) }}</v-list-item-title>
         </v-list-item-content>
      </v-list-item>
      <v-list-item>
          <v-list-item-icon><v-icon>$sentTotal</v-icon></v-list-item-icon>
          <v-list-item-content>
            <v-list-item-subtitle>{{$t('domain.blocked.stats.emailsSent')}}</v-list-item-subtitle>
            <v-list-item-title>{{ formatNumber(item.stats.emailsSent,0) }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-subheader>{{ $t('domain.blocked.stats.total').toUpperCase() }}</v-subheader>
      <v-list-item>
        <v-list-item-icon><v-icon>$visitors</v-icon></v-list-item-icon>
         <v-list-item-content>
           <v-list-item-subtitle>{{ $t('domain.blocked.stats.visitors') }}</v-list-item-subtitle>
           <v-list-item-title>{{ stats.monthlyUsers }}</v-list-item-title>
         </v-list-item-content>
      </v-list-item>
      <v-list-item>
          <v-list-item-icon><v-icon>$sentTotal</v-icon></v-list-item-icon>
          <v-list-item-content>
            <v-list-item-subtitle>{{$t('domain.blocked.stats.emailsSent')}}</v-list-item-subtitle>
            <v-list-item-title>{{ formatNumber(stats.emailsSent,0) }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <!--
      <v-list-item>
        <v-list-item-icon><v-icon>$sales</v-icon></v-list-item-icon>
         <v-list-item-content>
           <v-list-item-subtitle>{{ $t('domain.blocked.stats.sales') }}</v-list-item-subtitle>
           <v-list-item-title>{{ stats.dreamroiSales }}</v-list-item-title>
         </v-list-item-content>
      </v-list-item>
      -->
      </v-list>
      <v-card-actions>
        <v-btn text color="primary" :to="{name: 'plan'}">{{ $t('companies.selectPlan')}}</v-btn>
        <v-btn text :to="{name: 'billing'}">{{ $t('companies.reviewPaymentInfo')}}</v-btn>
        <v-btn text v-if="isHelpdesk" @click="showBlocked=false">{{ $t('dialog.close')}}</v-btn>
      </v-card-actions>
    </v-card>
    <v-skeleton-loader v-else type="card" />
    </v-dialog>
    </v-container>
</template>

<script>

  import { mapState, mapGetters } from "vuex";
  import ParseRoute from "@/mixins/parse-route";
  import Drawer from "@/mixins/drawer";
  //import WizardStepper from '@/components/WizardStepper';
  import Wizards from '@/mixins/wizards';
  import Formatters from '@/mixins/formatters'

  export default {
    name: 'Domain',
    components: { /* WizardStepper */ },
    mixins: [ParseRoute, Drawer, Wizards, Formatters ],
    data() {
      return {
        showBlocked: true
      };
    },
    computed: {
      menu() { 
      let menu =  [
        { id: 'menuDashboard', title: this.$t('dashboard.title'), icon: '$dashboard', to: { name: 'domain-dashboard'}, exact: true },
        { id: 'menuCampaigns', title: this.$t('campaigns.title'), open: this.item?.active == 'ACTIVE', group: "/campaigns/", icon: '$campaign', children: [
          { id: 'menuCAdd', title: this.$t('campaigns.add.title'), icon: '$add', to: { name: 'add-campaign'} , exact: true },
          { id: 'menuCSch', title: this.$t('campaigns.scheduled.title'), icon: '$scheduled', to: { name: 'campaigns-scheduled'} , exact: true },
          { id: 'menuCA', title: this.$t('campaigns.automatic.title'), icon: '$refresh', to: { name: 'campaigns-automatic'} , exact: true },
          { id: 'menuCBTC', title: this.$t('campaigns.btc.title'), icon: '$cart', to: { name: 'campaigns-btc'} , exact: true },
          { id: 'menuCSWU', title: this.$t('campaigns.swu.title'), icon: '$swu', to: { name: 'campaigns-swu'} , exact: true },
          { id: 'menuCW', title: this.$t('campaigns.welcome.title'), icon: '$welcome', to: { name: 'campaigns-welcome'} , exact: true },
        ]},
        { id: 'menuContacts',title: this.$t('contacts.title'), icon: '$segment', to: { name: 'contacts' }},
        
        { id: 'menuWebboxes',title: this.$t('webboxes.title'), icon: '$box', to: { name: 'webboxes' }},
        { id: 'menuSetup', title: this.$t('setup.title'), icon: '$settings', open: this.item?.active != 'ACTIVE', group: "/setup/", children: [
          { id: 'menuSetupO', title: this.$t('overview.title'), icon: '$overview', to: { name: 'domain-overview' } },
          { id: 'menuSetupF',title: this.$t('feeds.title'), icon: '$feed', to: { name: 'feeds' } },
          { id: 'menuSetupT',title: this.$t('tracking.title'), icon: '$tracking', to: { name: `tracking-${this.item && this.item.platform ? this.item.platform.toLowerCase() : 'other'}` } /*this.buildUrl(`tracking/${this.item && this.item.platform ? this.item.platform.toLowerCase() : 'other'}`)*/ },
          { id: 'menuSetupM',title: this.$t('mailing.title'), icon: '$mailing', to: { name: 'mailing' }},
          { id: 'menuForms',title: this.$t('forms.title'), icon: '$form', to: { name: 'forms' }},
          { id: 'menuSetupR',title: this.$t('integrations.title'), icon: '$integrations', to: { name: 'integrations' }},
          { id: 'menuSetupC',title: this.$t('customizations.title'), icon: '$customizations', to: { name: 'customizations' }}
        ]},
      ];
      if(this.isOwner || this.isHelpdesk) {
        menu.push({ id: 'menuAccess', title: this.$t('accessRights.title'), icon: '$access', to: { name: 'domain-access' }, owner: true });
      }
      if(this.isHelpdesk) {
        menu.push({ id: 'menuSetup', title: this.$t('insights.title'), icon: '$stats', to: { name: 'domain-schedule' }, helpdesk: true });
      }
      //menu.push({ id: 'menuSupport', title: 'Chat s podporou', icon: '$supportChat', color:'info', to: { name: 'domain-schedule' } })
      return menu;
      },
      
      isOwner() {
          return this.$store.getters['auth/isOwner']({ item: this.item })
      },
      ...mapState('domains', ['item']),
      ...mapGetters('companies', ['isActive', 'isBlocked', 'isTrial', 'subscription', 'stats']),
      ...mapGetters('auth', ['isHelpdesk'])
    },
    methods: {
    },
    created() {
      /*
      this.menu.filter(i => !!i.children).forEach(i => {
        console.debug(i.title);
        console.debug(this.$route.name);
        i.model = i.children.some(item => { console.debug(`${this.$route.name} ${item.to.name} ${this.$route.name == item.to.name}`);return this.$route.name == item.to.name});
      })
      */
    },
    mounted() {
      this.wizardLifecycleControl();
    }
  }
</script>
